/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ server: NonNullable<unknown> }} Audit_Details_Mcp_Server_Authorized_DescInputs */



/**
* | output |
* | --- |
* | "The MCP server \"{server}\" was authorized and now acts as the account that authorized it." |
*
* @param {Audit_Details_Mcp_Server_Authorized_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_mcp_server_authorized_desc = /** @type {((inputs: Audit_Details_Mcp_Server_Authorized_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Mcp_Server_Authorized_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der MCP-Server "${i?.server}" wurde autorisiert und handelt jetzt mit dem Konto, das ihn autorisiert hat.`)
	return /** @type {LocalizedString} */ (`The MCP server "${i?.server}" was authorized and now acts as the account that authorized it.`)
});